import { IPoi } from '../poi-model/poi';
import { IPoiPresenter } from './presenter-factory';

export abstract class PresenterBase implements IPoiPresenter {
    getShortAddress(poi: IPoi): string | undefined {
        const address = poi.getAddress();
        return address.shortFormattedAddress.get() || address.formattedAddress.get();
    }

    getCategoriesBullets(poi: IPoi): string[] | undefined {
        const categoryInfo = poi.getCategoryInfo();
        const group = categoryInfo.group.get();
        const category = categoryInfo.primary.get();

        const bullets: string[] = [];

        if (group) {
            bullets.push(group);
        }
        if (category && category !== group) {
            bullets.push(category);
        }
        return bullets.length ? bullets : undefined;
    }
}
